import { ReactNode } from "react";
import styled from "styled-components/macro";
import Typography from "ui/Typography";

const $TipContainer = styled.div`
  margin-bottom: 1.5rem;
  text-align: left;
  border-radius: 1rem;
  padding: 1rem;
  background-color: ${({ theme }) => theme.ColorWhite};
  display: flex;

  &:first-child {
    margin-top: 1.5rem;
  }
`;

const $ImageWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const $TipHeading = styled(Typography).attrs({
  size: "h4",
  forwardedAs: "h3",
})`
  font-weight: normal;
  line-height: 2rem;
`;

const $TipTextWrapper = styled.div`
  margin-left: 0.5rem;
`;

interface TipProps {
  description?: string;
  source: string;
  sourceSet: string;
  tip: string;
  className?: string;
  children?: ReactNode;
}

export default function Tip({
  children,
  className,
  description,
  source,
  sourceSet,
  tip,
}: TipProps) {
  const content = children ? children : description;
  return (
    <$TipContainer className={className}>
      <$ImageWrapper>
        <img alt="" src={source} srcSet={sourceSet} />
      </$ImageWrapper>
      <$TipTextWrapper>
        <$TipHeading>{tip}</$TipHeading>
        <Typography size="bodySansSerif">{content}</Typography>
      </$TipTextWrapper>
    </$TipContainer>
  );
}
